import { render, staticRenderFns } from "./atClubDetail.vue?vue&type=template&id=261a2bdc"
import script from "./atClubDetail.vue?vue&type=script&lang=js"
export * from "./atClubDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports